import script from './tag.vue_vue_type_script_lang.mjs';
export { default } from './tag.vue_vue_type_script_lang.mjs';
import { render } from './tag.vue_vue_type_template_id_525996c5_lang.mjs';

script.render = render;
script.__file = "packages/components/tag/src/tag.vue";
//# sourceMappingURL=tag2.mjs.map
